import { FC } from 'react';

/**
 * 쿠폰 상세 헤더 `발송` 그룹 세 기능의 역할 구분.
 * 이름이 비슷해 헷갈리기 쉬워 각 모달 머리에 같은 표를 띄우고 현재 기능만 강조한다.
 * - 답례인사 발송: 선택형. 받는 분이 링크로 상품을 직접 신청(선택)한다.
 * - 대리 일괄발송: 우리가 상품을 하나로 정해 신청 절차 없이 발송처리까지 끝낸다.
 * - 이용안내 발송: 이미 신청(수령)한 분들께 잘 쓰는 법 안내 멘트를 보낸다.
 */
export type SendRoleKey = 'courtesy' | 'proxyDeliver' | 'usageGuide';

export const SEND_ROLES: Array<{ key: SendRoleKey; label: string; role: string }> = [
  {
    key: 'courtesy',
    label: '답례인사 발송',
    role: '선택형 — 상품은 받는 분이 직접 신청',
  },
  {
    key: 'proxyDeliver',
    label: '대리 일괄발송',
    role: '우리가 상품 하나로 정해 신청 없이 발송처리까지',
  },
  {
    key: 'usageGuide',
    label: '이용안내 발송',
    role: '이미 신청한 분들께 잘 쓰는 법 안내 멘트',
  },
];

export const sendRoleOf = (key: SendRoleKey): string =>
  SEND_ROLES.find((r) => r.key === key)?.role ?? '';

export const SendRoleLegend: FC<{ current: SendRoleKey }> = ({ current }) => (
  <ul className="grid gap-0.5 rounded-lg border border-gray-200 bg-gray-50 px-3 py-2 text-[11px] leading-relaxed">
    {SEND_ROLES.map((r) => {
      const active = r.key === current;
      return (
        <li
          key={r.key}
          className={`flex gap-2 ${active ? 'font-bold text-gray-900' : 'text-gray-400'}`}
        >
          <span className="w-4 shrink-0 text-center">{active ? '▶' : ''}</span>
          <span className="w-24 shrink-0">{r.label}</span>
          <span className="min-w-0 flex-1">{r.role}</span>
        </li>
      );
    })}
  </ul>
);
